import React, {
  Suspense,
  useEffect,
  useState,
} from 'react';

import { KpiTabContent } from './KpiTabContent';

export function WorkstreamsTabPortals() {
  // Can't use React Router hooks here because the jQuery UI will use pushState to change tabs
  // which will not trigger React Router's re-render.
  // Use native browser APIs instead.
  const [searchParams, setSearchParams] = useState(new URLSearchParams(window.location.search));

  // Listen to history changes to update the search params
  useEffect(() => {
    const handleHistoryChange = (e: PopStateEvent) => {
      setSearchParams(new URLSearchParams((e.target as Window).location.search));
    };

    window.addEventListener('pushState', handleHistoryChange);
    window.addEventListener('popstate', handleHistoryChange);

    return () => {
      window.removeEventListener('pushState', handleHistoryChange);
      window.removeEventListener('popstate', handleHistoryChange);
    };
  }, [setSearchParams]);

  const teamView = searchParams.get('teamView');
  const teamId = searchParams.get('teamId');
  // `selectedTab` search param is intentionally ignored
  // because it is not a reliable way to determine which tab is active
  // when the team has KPIs but no OKRs (or vice versa).

  // Only show the KpiTabContent if the team view is enabled and the selected tab is the team view
  if (teamView === null || !teamId) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <KpiTabContent teamId={teamId} />
    </Suspense>
  );
}
